module.exports = __webpack_public_path__ + "static/media/maxie.64f79bfc.PNG";